// extracted by mini-css-extract-plugin
export var articleContent = "reference-content-module--article-content--7eee7";
export var center = "reference-content-module--center--b7ee6";
export var container = "reference-content-module--container--f7bd3";
export var descriptionContent = "reference-content-module--description-content--3ce59";
export var sourceText = "reference-content-module--sourceText--bbf10";